import axios from "axios";
import { baseUrl, extendHeaders, headers } from "./HelpService";



const PageUrl = baseUrl + 'invoices/';

const downloadReimbursementsToCharge = (account_id, invoice_id=null) => {
    var params = { account_id: account_id };
    if (invoice_id) {
        params['invoice_id'] = invoice_id;
    };

    axios({
        url: PageUrl + `downloadReimbursementsToCharge/?${new URLSearchParams(params).toString()}`,
        method: 'GET',
        headers: headers(),
        responseType: 'blob'
    }).then((response) => {
        const contentType = response.headers['content-type'];
        if (contentType && contentType.toLowerCase().includes('application/vnd.openxmlformats')) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `reimbursements.xlsx`);
            document.body.appendChild(link);
            link.click();
        } else {
            alert('no data');
        }
    })
};

const getBillingsInfo = (accountId: number) => {
    return fetch(`${PageUrl}getBillingsInfo/?account_id=${encodeURIComponent(accountId)}`, {
        method: "GET",
        headers: extendHeaders(),
    })
        .then((response: any) => response.json())
        .catch((error) => {
            return null;
        });
};

const getInvoiceDetailsPage = (accountId: number, invoiceId) => {
    return fetch(`${PageUrl}getInvoiceDetailsPage/?account_id=${encodeURIComponent(accountId)}
    &invoice_id=${encodeURIComponent(invoiceId)}`, {
        method: "GET",
        headers: extendHeaders(),
    })
        .then((response: any) => response.json())
        .catch((error) => {
            return null;
        });
};

const InvoicesService = {
    downloadReimbursementsToCharge,
    getBillingsInfo,
    getInvoiceDetailsPage
};

export default InvoicesService;
